import { ComponentPropsWithoutRef } from 'react';
import { Typography } from '../../../ui';

export function Bold(props: ComponentPropsWithoutRef<'b'>) {
  const { children, ...rest } = props;

  return (
    <Typography as="strong" weight="medium" {...rest}>
      {children}
    </Typography>
  );
}
